import React, { useState } from 'react';
import api from '../services/api';

// Возвращает строку вида "YYYY-MM-DD" для первого числа текущего месяца
const getFirstDayOfCurrentMonth = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
};

// Возвращает строку вида "YYYY-MM-DD" для последнего числа текущего месяца
const getLastDayOfCurrentMonth = () => {
    const now = new Date();
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return `${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
};

// Компонент формы отчёта ПИР за период
const OrdersReportForm = () => {
    const [dateFrom, setDateFrom] = useState(getFirstDayOfCurrentMonth);
    const [dateTo, setDateTo] = useState(getLastDayOfCurrentMonth);
    const [dateStatementFrom, setDateStatementFrom] = useState(getFirstDayOfCurrentMonth);
    const [dateStatementTo, setDateStatementTo] = useState(getLastDayOfCurrentMonth);
    const [exporting, setExporting] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' | 'error'

    const handleExport = async (e) => {
        e.preventDefault();
        if (!dateFrom || !dateTo) {
            setMessage('Пожалуйста, укажите период приказов');
            setMessageType('error');
            return;
        }
        if (!dateStatementFrom || !dateStatementTo) {
            setMessage('Пожалуйста, укажите период оплат');
            setMessageType('error');
            return;
        }

        setExporting(true);
        setMessage('');
        setMessageType('');

        try {
            const response = await api.exportOrdersByDateReceiptPeriod(
                dateFrom,
                dateTo,
                dateStatementFrom,
                dateStatementTo
            );

            // Получаем имя файла из заголовка Content-Disposition, если есть
            const disposition = response.headers.get('Content-Disposition') || '';
            const match = disposition.match(/filename="?([^";\n]+)"?/);
            const fileName = match ? match[1] : `Отчёт_ПИР_${dateFrom}_${dateTo}.xlsx`;

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);

            setMessage(`Файл "${fileName}" успешно выгружен`);
            setMessageType('success');
        } catch (error) {
            setMessage('Ошибка при выгрузке данных');
            setMessageType('error');
            console.error('Export error:', error);
        } finally {
            setExporting(false);
        }
    };

    return (
        <div className="upload-container" style={{ marginTop: '20px' }}>
            <h3 style={{ marginBottom: '16px' }}>Создание отчёта ПИР за период</h3>
            (* Выборка приказов производится по полю "Дата получения ИД взыскателем")
            <form onSubmit={handleExport} className="upload-form">
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                    <div className="form-group" style={{ minWidth: '160px' }}>
                        <label htmlFor="report-date-from">Дата с:</label>
                        <input
                            type="date"
                            id="report-date-from"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group" style={{ minWidth: '160px' }}>
                        <label htmlFor="report-date-to">Дата по:</label>
                        <input
                            type="date"
                            id="report-date-to"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            required
                        />
                    </div>
                </div>

                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'flex-end', marginTop: '16px' }}>
                    <div style={{ width: '100%', marginBottom: '4px', fontWeight: '500', color: '#555' }}>
                        Указать период оплат:
                    </div>
                    <div className="form-group" style={{ minWidth: '160px' }}>
                        <label htmlFor="report-statement-date-from">Дата с:</label>
                        <input
                            type="date"
                            id="report-statement-date-from"
                            value={dateStatementFrom}
                            onChange={(e) => setDateStatementFrom(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group" style={{ minWidth: '160px' }}>
                        <label htmlFor="report-statement-date-to">Дата по:</label>
                        <input
                            type="date"
                            id="report-statement-date-to"
                            value={dateStatementTo}
                            onChange={(e) => setDateStatementTo(e.target.value)}
                            required
                        />
                    </div>
                    <div className="form-group" style={{ marginBottom: '40' }}>
                        <button
                            type="submit"
                            className="btn-primary"
                            disabled={exporting}
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            {exporting ? 'Создание...' : 'Создать'}
                        </button>
                    </div>
                </div>
            </form>

            {message && (
                <div
                    className={`message ${messageType === 'error' ? 'error' : 'success'}`}
                    style={{ marginTop: '12px' }}
                >
                    {message}
                </div>
            )}
        </div>
    );
};

const Reports = () => {
    const [activeSection, setActiveSection] = useState('orders-report');

    const menuItems = [
        { key: 'orders-report', label: 'Отчёт ПИР за период' }
    ];

    return (
        <div className="page">
            <h2>Отчёты</h2>

            {/* Горизонтальная панель кнопок */}
            <div className="page-header" style={{ justifyContent: 'flex-start', gap: '15px' }}>
                {menuItems.map(item => (
                    <button
                        key={item.key}
                        onClick={() => setActiveSection(item.key)}
                        className={`btn-with-badge ${activeSection === item.key ? 'btn-primary' : 'btn-secondary'}`}
                    >
                        {item.label}
                    </button>
                ))}
            </div>

            {/* Основной контент */}
            <div className="reports-content" style={{ marginTop: '20px' }}>
                {activeSection === 'orders-report' && <OrdersReportForm />}
            </div>
        </div>
    );
};

export default Reports;
